import PropTypes from 'prop-types';
import { LoadingSpinner as Spinner } from 'jl-design-system/components/loading-spinner/LoadingSpinner';
import classNames from 'classnames';

import styles from './LoadingSpinner.scss';

export const LoadingSpinner = ({
  centered,
  spinnerStyle,
  loadingSpinnerStyle = {},
  extraClassName = '',
}) => (
  <div
    id="loading-spinner"
    className={classNames(styles.LoadingSpinner, extraClassName, {
      [styles.Default]: !spinnerStyle,
      [styles.loadingSpinnerContainer]: centered,
    })}
    style={loadingSpinnerStyle}
  >
    <Spinner style={spinnerStyle} />
  </div>
);

LoadingSpinner.propTypes = {
  extraClassName: PropTypes.string,
  spinnerStyle: PropTypes.shape({}),
  loadingSpinnerStyle: PropTypes.shape({}),
};
